import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpEvent } from '@angular/common/http'; // <-- Importa HttpEvent
import { Observable } from 'rxjs';
import { environment } from "../environments/environment.production";

@Injectable({
  providedIn: 'root'
})
export class DocumentoService {

  private endPoint: string = `${environment.HOST_DOCUMENT}/documentos`;

  constructor(private http: HttpClient) { }

  /**
   * Sube un archivo y reporta el progreso del evento.
   * @returns Un Observable de tipo HttpEvent para rastrear el progreso.
   */
  subirDocumentoPdf(rfc: string, idDocumentoTramite: number, archivo: File): Observable<HttpEvent<any>> { // <-- CAMBIO: El tipo de retorno ahora es HttpEvent

    const url = `${this.endPoint}/subirDocumentosPdf`;

    const params = new HttpParams()
      .set('strRfc', rfc)
      .set('strIdDocumentoTramite', idDocumentoTramite);

    const formData = new FormData();
    formData.append('file', archivo, archivo.name);

    
    // Se envía la petición POST, pero ahora con opciones para observar los eventos
    return this.http.post(url, formData, {
      params: params,
      reportProgress: true, // <-- CAMBIO: Activa el reporte de progreso
      observe: 'events'     // <-- CAMBIO: Observa todos los eventos, no solo la respuesta final
    });
  }


}
